<template>
  <div
    class="diy-imageSingle"
    :style="'padding-bottom:'+itemStyle.paddingTop+'px; background:'+itemStyle.background"
  >
    <div
      class="item-image"
      v-for="(dataItem,index) in datalist"
      :key="index"
      :style="'padding:'+itemStyle.paddingTop+'px'+itemStyle.paddingLeft+'px 0'"
    >
      <div class="nav-to" @click="navigationTo(dataItem.linkUrl)" :data-url="dataItem.linkUrl">
        <img :src="dataItem.imgUrl" style="width:100%;float:left">
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "datalist"],
  created() {},
  activated() {},
  methods: {
    navigationTo(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-imageSingle .item-image image {
  display: block;
  width: 100%;
}
.nav-to {
  overflow: hidden;
  position: relative;
}
</style>